import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Adiciona um botão "recolher/expandir" a todos os boxes brancos do sistema
// (div.bg-white.rounded-xl|2xl com cabeçalho contendo h2/h3), exceto cards de residentes e diálogos.
const KEY = "crsj_boxes_recolhidos";
const lerEstado = () => { try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; } };
const salvarEstado = (o) => { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch { /* noop */ } };

const SELETOR = "div.bg-white.rounded-xl, div.bg-white.rounded-2xl";
const ICON_ABERTO = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m18 15-6-6-6 6"/></svg>';
const ICON_FECHADO = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>';

const chaveDe = (card, path) => {
  const h = card.firstElementChild?.querySelector("h2, h3");
  return `${path}::${(card.dataset.testid || "")}::${(h?.textContent || "").trim().slice(0, 60)}`;
};

const aplicar = (card, recolhido) => {
  card.dataset.boxRecolhido = recolhido ? "1" : "0";
  const btn = card.querySelector(":scope > .__box-toggle");
  if (btn) { btn.innerHTML = recolhido ? ICON_FECHADO : ICON_ABERTO; btn.title = recolhido ? "Expandir" : "Recolher"; }
};

const preparar = (path) => {
  const estado = lerEstado();
  document.querySelectorAll(SELETOR).forEach((card) => {
    if (card.dataset.boxToggle) return;
    if (card.closest("[role='dialog'], [data-testid^='residente-card-'], [data-testid='tv-card'], .__no-box-toggle")) return;
    const head = card.firstElementChild;
    if (!head || !head.querySelector("h2, h3, h4, .font-semibold")) return;
    if (head.matches("table, form, input, ul")) return;
    if (card.children.length < 2) return;
    card.dataset.boxToggle = "1";
    if (!card.style.position && getComputedStyle(card).position === "static") card.style.position = "relative";
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "__box-toggle";
    btn.setAttribute("data-testid", "box-toggle");
    btn.setAttribute("aria-label", "Recolher ou expandir");
    const k = chaveDe(card, path);
    btn.addEventListener("click", (e) => {
      e.preventDefault(); e.stopPropagation();
      const est = lerEstado();
      const novo = card.dataset.boxRecolhido !== "1";
      if (novo) est[k] = 1; else delete est[k];
      salvarEstado(est);
      aplicar(card, novo);
    });
    card.appendChild(btn);
    aplicar(card, !!estado[k]);
  });
};

export const useBoxToggles = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    let raf = 0;
    const run = () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => preparar(pathname)); };
    run();
    const obs = new MutationObserver(run);
    obs.observe(document.body, { childList: true, subtree: true });
    return () => { obs.disconnect(); cancelAnimationFrame(raf); };
  }, [pathname]);
};
